import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ILicenseConsumptionInfo } from '../types/ILicenseConsumptionInfo';

export class GetServerLicensingConsumptionInfoRequest extends Request<{}, ILicenseConsumptionInfo> {
  constructor() {
    super('getServerLicensingConsumptionInfo', {});
  }
}
